import React from 'react';
import { TRANSLATIONS } from '../../../../translations';

import Card, { CardSizes } from '../../../ui-components/Card/Card';
import Image from '../../../ui-components/Image/Image';
import Typography from '../../../ui-components/Typography/Typography';
import pages from '../../../define/pages';

function SmartSearchGeolocator() {
  return (
    <Card
      className={'items-center'}
      image={
        <Image
          source={
            'https://freedome.s3.eu-central-1.amazonaws.com/icons/locator-icon.svg'
          }
          alt={'Icona di un ago di bussola'}
          size={'small'}
          shape={'rounded'}
          asBackground
          overlaid
        />
      }
      size={CardSizes.full}
      link={`${window.location.origin}${pages.catalogue}`}
      content={
        <Typography variant={'p2'} state={'underlined'}>
          {TRANSLATIONS.CLOSE_TO_ME}
        </Typography>
      }
    />
  );
}

export default SmartSearchGeolocator;
